import React from "react";
import { FaCopyright } from "react-icons/fa";
import { useSelector } from "react-redux";
const Footer = () => {
  const theme = useSelector((state) => state.theme.theme);
  return (
    <div
      className={
        theme === "light"
          ? " w-full bg-slate-200 outline-dashed text-black py-7 px-4  "
          : " w-full bg-gray-900 outline-dashed text-white py-7 px-4 "
      }
    >
      <div className="container mx-auto sticky top-[100vh] flex  items-center justify-between">
        <div>
          <h1
            className={
              theme === "light"
                ? "font-semibold text-[15px] lg:text-[24px] cursor-pointer hover:text-gray-300 transition-all delay-20 tracking-wide text-black"
                : "font-semibold text-[15px] lg:text-[24px] cursor-pointer hover:text-gray-300 transition-all delay-20 tracking-wide text-white"
            }
          >
            {" "}
            Naveen Kumar
          </h1>
        </div>
        <div>
          <h1
            className={
              theme === "light"
                ? " text-black text-[15px] lg:text-[18px] flex justify-between items-center gap-1 lg:gap-2 "
                : " text-white text-[15px] lg:text-[18px] flex justify-between items-center gap-1 lg:gap-2 "
            }
          >
            <FaCopyright /> {new Date().getFullYear()} Naveen Kumar
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Footer;
